import { CantileverButton } from 'components/CantileverButton'
import {
  KNOWLEDGE_DOC_SIDEBAR_TOGGLE,
  useGeckoAnalytics,
} from 'features/analytics'
import { FeedbackModal } from 'features/knowledgeDocumentViewer/components/sidebar/FeedbackModal'
import { useKnowledgeDocumentDataContext } from 'features/knowledgeDocumentViewer/contexts/KnowledgeDocumentDataContext'
import { useKnowledgeDocumentUXContext } from 'features/knowledgeDocumentViewer/contexts/KnowledgeDocumentUXContext'
import { ArrowLeft, ArrowRight, Flag, PanelRight } from 'lucide-react'
import { useState } from 'react'
import styled from 'styled-components'

import { DocumentHeaderTitle } from './DocumentHeaderTitle'
import { PageSelector } from './PageSelector'
import { PrintDocumentButton } from './PrintDocumentButton'
import { SettingsMenu } from './SettingsMenu'

const StyledHeader = styled.header`
  background-color: ${(props) => props.theme.forecast.pageBackground1};
  display: flex;
  align-items: center;
  padding: 0.5rem 0.75rem;
  gap: 0.75rem;
`

const ButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.25rem;
`

const TrailingButtonsContainer = styled(ButtonsContainer)`
  margin-left: auto;
`

const BackFwdContainer = styled(ButtonsContainer)`
  gap: 1px;
`

const PageSelectorContainer = styled.div`
  margin-right: 1rem;
`

export function KnowledgeDocumentHeaderBar() {
  const { trackEvent } = useGeckoAnalytics()
  const {
    currentDocumentId,
    isSidebarCollapsed,
    setIsSidebarCollapsed,
    activeTabId,
    canGoBack,
    canGoForward,
    goBack,
    goForward,
    isOnLinkedDocuments,
    currentLinkedDocumentsData,
  } = useKnowledgeDocumentUXContext()

  const { siteID } = useKnowledgeDocumentDataContext()

  const [isDocumentFeedbackModalOpen, setIsDocumentFeedbackModalOpen] =
    useState(false)

  function handleSidebarToggle() {
    trackEvent(KNOWLEDGE_DOC_SIDEBAR_TOGGLE.title, {
      action: isSidebarCollapsed ? 'expand' : 'collapse',
    })
    setIsSidebarCollapsed(!isSidebarCollapsed)
  }

  return (
    <>
      <StyledHeader>
        <BackFwdContainer>
          <CantileverButton
            iconOnly
            title='Back'
            disabled={!canGoBack}
            onClick={() => goBack(activeTabId)}
            style={{ borderRadius: '0.25rem 0 0 0.25rem' }}>
            <ArrowLeft size={18} />
          </CantileverButton>
          <CantileverButton
            iconOnly
            title='Forward'
            disabled={!canGoForward}
            onClick={() => goForward(activeTabId)}
            style={{ borderRadius: '0 0.25rem 0.25rem 0' }}>
            <ArrowRight size={18} />
          </CantileverButton>
        </BackFwdContainer>

        <DocumentHeaderTitle
          documentId={currentDocumentId}
          customTitle={
            currentLinkedDocumentsData
              ? `References to ${currentLinkedDocumentsData.referenceText}`
              : undefined
          }
        />

        <TrailingButtonsContainer>
          {!isOnLinkedDocuments && (
            <>
              <PageSelectorContainer>
                <PageSelector />
              </PageSelectorContainer>
              <CantileverButton
                iconOnly
                onClick={() => setIsDocumentFeedbackModalOpen(true)}
                title='Report Document Issue'>
                <Flag size={18} strokeWidth={1.5} />
              </CantileverButton>

              <PrintDocumentButton />

              <SettingsMenu />

              <CantileverButton
                iconOnly
                onClick={handleSidebarToggle}
                title={isSidebarCollapsed ? 'Show Sidebar' : 'Hide Sidebar'}>
                <PanelRight size={18} strokeWidth={1.5} />
              </CantileverButton>
            </>
          )}
        </TrailingButtonsContainer>
      </StyledHeader>
      <FeedbackModal
        feedbackType='document'
        isOpen={isDocumentFeedbackModalOpen}
        onClose={() => setIsDocumentFeedbackModalOpen(false)}
        documentId={currentDocumentId}
        siteId={siteID}
        title='Report Document Issue'
      />
    </>
  )
}

export default KnowledgeDocumentHeaderBar
